import { render, staticRenderFns } from "./ResetPassForm.vue?vue&type=template&id=3f8e728b&scoped=true&"
import script from "./ResetPassForm.vue?vue&type=script&lang=ts&"
export * from "./ResetPassForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8e728b",
  null
  
)

export default component.exports